/// <reference path="./../../_all.ts"/>

module Shared {
    export interface INotificationService {
        getTileNotifications(silentMode?: boolean): ng.IPromise<Shared.GetNotificationsResponse>;
        getAlertNotifications(silentMode): ng.IPromise<Shared.GetNotificationsResponse>;
        closeNotification(notification: Notification) : ng.IPromise<boolean>;
    }
}

(() => {
    'use strict';

    angular
        .module('app.shared')
        .service('notificationSrv', notificationSrv);

    notificationSrv.$inject = ['$http', 'shared.config'];

    function notificationSrv($http, sharedConfig) {

        var service:any = {};
        var serviceBase = sharedConfig.baseApiUrl;

        // Methods
        service.getTileNotifications = getTileNotifications;
        service.closeNotification = closeNotification;
        service.getAlertNotifications = getAlertNotifications;

        function getTileNotifications(silentMode): ng.IPromise<Shared.GetNotificationsResponse> {
            return $http.get(serviceBase + 'api/Notifications/GetTileNotifications', {
                params: {
                    silentMode: silentMode ? silentMode : false
                },
                cache: true
            }).then((response) => {
                return response.data;
            });
        }

        function getAlertNotifications(silentMode): ng.IPromise<Shared.GetNotificationsResponse> {
            return $http.get(serviceBase + 'api/Notifications/GetAlertNotifications', {
                params: {
                    silentMode: silentMode ? silentMode : false
                },
                cache: true
            }).then((response) => {
                return response.data;
            });
        }

        function closeNotification(notification) {
            return $http.delete(serviceBase + "api/Notifications/DeleteNotification/" + notification.id)
                .then((response) => {
                    return response.data;
                });
        }

        return service;
    }
})();
